import { Injectable } from '@angular/core';
import { IUser } from '@shared/interfaces';
import { LocalService } from '@shared/services/local.service';
import { BehaviorSubject } from 'rxjs';
import { UserRole } from '@shared/enums/UserRole';

@Injectable({
    providedIn: 'root'
})
export class GuardService {
    public currentUserSubscribable = new BehaviorSubject<IUser>(null);

    constructor(private localService: LocalService) {}

    private _currentUser: IUser;

    get currentUser(): IUser {
        if (!this._currentUser) {
            this.currentUser = this.localCurrentUser;
        }
        return this._currentUser;
    }

    set currentUser(user: IUser) {
        this._currentUser = user;
        this.currentUserSubscribable.next(user);
    }

    get mainUser() {
        return this.currentUser.mainUser;
    }

    public get isAdmin(): boolean {
        if (!this.currentUser) {
            this.currentUser = this.localCurrentUser;
        }
        return this.currentUser && this.currentUser.userRole === UserRole.admin;
    }

    public get isActive(): boolean {
        if (!this.currentUser) {
            this.currentUser = this.localCurrentUser;
        }
        return !!this.currentUser;
    }

    private get localCurrentUser(): IUser {
        return this.localService.get('current_user') as IUser;
    }

    get isMaster(): boolean {
        return (
            this.currentUser &&
            ((this.currentUser.id === 'Z003X1DP' && !this.currentUser.mainUser) ||
                this.currentUser.mainUser?.id === 'Z003X1DP')
        );
    }
}
